import { render } from "./EditVerticalFeed.vue?vue&type=template&id=5eb32bff"
import script from "./EditVerticalFeed.vue?vue&type=script&lang=js"
export * from "./EditVerticalFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__